import CrashPage from './CrashPage'

export default CrashPage
